import styled from 'styled-components';

import { COLORS } from 'theme';

export const MileageContainer = styled.div`
  color: ${({ $outOfLimit }) => ($outOfLimit ? COLORS.red : null)};
`;
